import { getApolloClient } from '@faustwp/core';
import { BlogListPage } from '../../components/BlogListPage';
import { fetchBlogListData } from '../../lib/blogUtils';
import { getBaseCategoryForLang } from '../../constants/blogCategories';

export default function BlogiIndexPage({ posts, generalSettings, useAcfQuery }) {
  return (
    <BlogListPage
      posts={posts}
      generalSettings={generalSettings}
      lang="fi"
      basePath="/blogi"
      useAcfQuery={useAcfQuery}
    />
  );
}

export async function getStaticProps() {
  try {
    const client = getApolloClient();
    const baseCategory = getBaseCategoryForLang('fi');
    const variables = { categorySlug: baseCategory, first: 200 };
    const { posts, generalSettings, useAcfQuery } = await fetchBlogListData(client, variables, { lang: 'fi' });
    return {
      props: { posts: posts ?? [], generalSettings: generalSettings ?? null, useAcfQuery: useAcfQuery ?? false },
      revalidate: 60,
    };
  } catch (err) {
    console.error('[blogi/index] getStaticProps failed', err);
    return {
      props: { posts: [], generalSettings: null, useAcfQuery: false },
      revalidate: 60,
    };
  }
}
